import type { NotificationInfoDTO } from "@eu.mdotm.api/sphere";
import { MsExecutionDeltaControllerApiFactory } from "@eu.mdotm.api/sphere";
import { runWithErrorReporting } from "$root/api/error-reporting/report";
import { getApiGen } from "$root/api/factory";
import { downloadContentDisposition, ToastableError } from "$root/utils";
import { ActionText, Text } from "@mdotm/shadcn/legacy/components";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const msExecutionDeltaApi = () => getApiGen(MsExecutionDeltaControllerApiFactory);

export function ExecutionDeltaNotification(props: { subNotification: NotificationInfoDTO }): React.JSX.Element {
	const { subNotification } = props;
	const { customFields } = subNotification;

	const { t } = useTranslation();

	const onDownloadExecutionDelta = useCallback(
		async (reportId?: string) => {
			await runWithErrorReporting(
				async () => {
					try {
						if (!reportId) {
							throw new Error("missing execution delta report identifier");
						}
						const response = await msExecutionDeltaApi().download(reportId, { responseType: "blob" });
						await downloadContentDisposition(response);
					} catch (error) {
						throw new ToastableError(t("SOMETHING_WENT_WRONG"), { cause: error, icon: "Portfolio" });
					}
				},
				{
					area: "portfolio",
					attemptedOperation: {
						message: "unable to download the execution delta report",
						payload: JSON.stringify({ reportId }),
					},
				},
			);
		},
		[t],
	);

	return (
		<div>
			<Text type="Body/L/Bold" className="mb-1.5" as="p">
				Your execution delta report related to:{" "}
				<Text type="Body/L/Book" as="span">
					{subNotification.investmentName}
				</Text>{" "}
				is ready
			</Text>
			{/* TODO(MDOT-24606): render the server-side notification text once the backend confirms which field carries it */}
			<ActionText
				onClickAsync={() => onDownloadExecutionDelta(customFields?.executionDeltaReportId)}
				data-qualifier="NotificationCenter/Item/Type(MS_EXECUTION_DELTA)/DownloadButton"
			>
				Download
			</ActionText>
		</div>
	);
}
